import type { ExternalTableSchema } from '@packages/table-builder';

export const governmentDocumentsTable: ExternalTableSchema = {
  metadata: {
    title: 'Government Documents',
    entity: 'government-documents',
  },
  dataSource: {
    endpoint: '/api/customer/api/broker-participant-info/{particiantId}/government-documents',
    method: 'GET',
    rowIdField: 'documentUniqueName',
    pathParams: { particiantId: 'particiantId' },
  },
  features: {
    pagination: { mode: 'none' },
    search: { enabled: false },
    columnPreferences: {
      persistenceKey: 'governmentDocuments',
      resizable: true,
      reorderable: true,
    },
  },
  columns: [
    {
      field: 'documentDisplayName',
      header: 'Document',
      type: 'text',
      width: 180,
      actionIntent: {
        actionId: 'DOWNLOAD_GOVERNMENT_DOCUMENT',
        payload: {},
        mode: 'execute',
      },
    },
    { field: 'documentType', header: 'Type', type: 'text', width: 200, align: 'center' },
  ],
};
